import { FC, HTMLAttributes, useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import EyeIcon from 'components/Common/Icons/Eye'
import EyeInvisibleIcon from 'components/Common/Icons/EyeInvisible'
import {
  Wrapper,
  Container,
  Block,
  IconWrapper,
  IconBlock,
  Icon,
  Error,
} from 'components/Pages/ConfirmPassword/Left/Main/Form/Main/PasswordInput/_styles'
import { Input } from 'components/Common/MasterComponents'

interface PasswordInputProps extends HTMLAttributes<HTMLInputElement> {
  label: string
  error: string
  autoComplete?: string
  testId?: string
}

const PasswordInput: FC<PasswordInputProps> = ({
  label,
  error,
  testId,
  ...props
}) => {
  const { t } = useTranslation()

  const id = useId()

  const [type, setType] = useState('password')
  const toggle = () => {
    setType(type === 'password' ? 'text' : 'password')
  }

  return (
    <Wrapper>
      <Container>
        <Block>
          <Input
            label={label}
            type={type}
            id={id}
            maxLength={50}
            spellCheck='false'
            hasError={!!error}
            data-testid={testId ? `${testId}-input` : undefined}
            {...props}
          />
        </Block>
        <IconWrapper data-testid={testId ? `${testId}-toggle` : undefined}>
          <IconBlock onClick={toggle}>
            <Icon>
              {type === 'password' ? (
                <EyeInvisibleIcon size={16} color={'var(--color-sw-60)'} />
              ) : (
                <EyeIcon size={16} color={'var(--color-sw-60)'} />
              )}
            </Icon>
          </IconBlock>
        </IconWrapper>
      </Container>
      {error && (
        <Error data-testid={testId ? `${testId}-error` : undefined}>
          {t(error)}
        </Error>
      )}
    </Wrapper>
  )
}

export default PasswordInput
